
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 12.727c.928 0 1.819-.383 2.475-1.065A3.71 3.71 0 0010.5 9.091V3.636a3.71 3.71 0 00-1.025-2.57A3.435 3.435 0 007 0c-.928 0-1.819.383-2.475 1.065A3.71 3.71 0 003.5 3.636v5.455c0 .964.369 1.89 1.025 2.571A3.435 3.435 0 007 12.727zm-1.75-9.09c0-.483.184-.945.513-1.286A1.717 1.717 0 017 1.818c.464 0 .91.192 1.237.533.329.34.513.803.513 1.285v5.455c0 .482-.184.945-.513 1.286-.328.34-.773.532-1.237.532-.464 0-.91-.192-1.237-.532A1.855 1.855 0 015.25 9.09V3.636zM14 9.09a.927.927 0 00-.256-.643.859.859 0 00-.619-.266.859.859 0 00-.619.266.927.927 0 00-.256.643 5.564 5.564 0 01-1.538 3.857A5.152 5.152 0 017 14.546a5.152 5.152 0 01-3.712-1.598A5.565 5.565 0 011.75 9.09a.927.927 0 00-.256-.643.859.859 0 00-.619-.266.859.859 0 00-.619.266.927.927 0 00-.256.643 7.438 7.438 0 001.752 4.806A6.923 6.923 0 006.125 16.3v1.882h-1.75a.859.859 0 00-.619.266.927.927 0 00-.256.643c0 .241.092.472.256.643.164.17.387.266.619.266h5.25a.859.859 0 00.619-.266.927.927 0 00.256-.643.927.927 0 00-.256-.643.859.859 0 00-.619-.266h-1.75V16.3a6.923 6.923 0 004.373-2.403A7.437 7.437 0 0014 9.091z"}})])
          )
        }
      }
    